import groupBy from "lodash/groupBy";
/**
 * This method will filter all A.I commands based on the current query
 * and the command visible states.
 */
export const filterCommands = (commands, state, query) => {
    return commands
        .filter((command) => {
        if (!command.states) {
            return true;
        }
        return command.states.includes(state);
    })
        .filter((command) => {
        if (!query) {
            return true;
        }
        return command.label.toLowerCase().includes(query.toLowerCase());
    })
        .map((command, index) => ({
        ...command,
        index,
    }));
};
/** This method will group all A.I commands and return a tuple,
 * with the grouped commands and also the ordered commands with their correct index/position pairs
 * this ordered list should be used to get the selected command based on activeIndex */
export const groupCommands = (commands, groupLabels) => {
    let index = 0;
    const grouped = groupBy(commands, (command) => command.group);
    const { groups, items } = Object.entries(grouped).reduce((carry, [group, items]) => {
        const groupItems = items.map((item) => ({ ...item, index: index++ }));
        return {
            groups: [
                ...carry.groups,
                {
                    label: groupLabels[group] || groupLabels.default,
                    items: groupItems,
                },
            ],
            items: [...carry.items, ...groupItems],
        };
    }, {
        groups: [],
        items: [],
    });
    return [groups, items];
};
